import React, { MouseEventHandler, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import HomeBarButton from '@core/dashboard/components/HomeBarButton';
import { HandPalmIcon } from '@icons';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { FAMILIARISE_STATE } from '@core/dashboard/components/HomeBottomBar/constants';
import { useClientSpecificDashboardButtonDisabled } from '@hooks/clientSpecificUtils';
import { DashboardButtonEnum } from '@constants/dashboard';

const RaiseHandButton = () => {
  const { t: translate } = useTranslation();
  const { isHandRaised, toggleRaiseHand, familiarizeState } =
    useMytaverseEvent();

  const isDisabledClientSpecific = useClientSpecificDashboardButtonDisabled(
    DashboardButtonEnum.RISE_HAND_BUTTON,
  );

  const handleToggleRaiseHand: MouseEventHandler<HTMLButtonElement> =
    useCallback(() => {
      toggleRaiseHand();
    }, [toggleRaiseHand]);

  return (
    <HomeBarButton
      label={translate('tooltips.raiseHand')}
      icon={<HandPalmIcon />}
      isActive={
        isHandRaised || familiarizeState?.name === FAMILIARISE_STATE.RISE_HAND
      }
      handleClick={handleToggleRaiseHand}
      disabled={isDisabledClientSpecific}
    />
  );
};

export default RaiseHandButton;
